import React, { useContext } from 'react';
import Modal from 'react-modal';
import { Puff } from 'react-loader-spinner';
import { appContext } from '../context/ContextProvider';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '50%',
    border: 'none',
    background: 'none',
    zIndex: '999999'
  }
};

function AppLoader({ showLoader, setShowLoader, loadingText }) {
  return (
    <Modal isOpen={showLoader} style={customStyles}>
      <div className='items-center justify-center flex'>
        <div class='progress'></div>
      </div>
    </Modal>
  );
}

export default AppLoader;
